export default __webpack_public_path__ + "static/media/na.226c840a.jpg";